// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uplous .el-button.is-disabled {\n  color: #298FF8;\n}", ""]);
// Exports
module.exports = exports;
